import { Howl } from 'howler';
import { hasFirstInteraction } from './display';
import { Store } from 'game/store/gameStore';

type SoundElements = { [name: string]: { instance: Howl; volume: number } };

export type SoundConfigOptions = {
    loop?: boolean;
    autoplay?: boolean;
    volume?: number;
    delay?: number;
    name?: string;
    force?: boolean;
    vibrate?: number | number[];
};
export type SoundConfig = {
    loop: boolean;
    autoplay: boolean;
    volume: number;
    delay: number;
    name: string;
    force: boolean;
    vibrate: number | number[];
};
const defaultSoundConfig = {
    volume: 1,
    loop: false,
    autoPlay: false,
    force: false,
    delay: 0,
    vibrate: 0,
} as SoundConfigOptions;

class SoundController {
    initialized: boolean;
    soundsList: SoundElements;
    volume: number;

    constructor() {
        this.initialized = false;
        this.soundsList = {} as SoundElements;
        this.volume = 1;
        this.play = this.play.bind(this);
        this.mute = this.mute.bind(this);
        this.setVolume = this.setVolume.bind(this);
    }

    play(name: string, config = defaultSoundConfig) {
        let soundItem = this.soundsList[name];

        if (!Store.soundOn) return soundItem;
        if (!hasFirstInteraction()) return soundItem;

        const fullConfig = { ...defaultSoundConfig, ...config } as SoundConfig;
        if (!Store.soundOn) return soundItem;

        if (!soundItem) {
            console.error('no preloaded sound for ', name);
            return soundItem;
        }
        soundItem.instance.volume(fullConfig.volume);
        soundItem.instance.loop(fullConfig.loop);
        if (fullConfig.delay) {
            setTimeout(
                (instance) => {
                    instance.play();
                },
                fullConfig.delay,
                soundItem.instance
            );
        } else soundItem.instance.play();
        soundItem.volume = fullConfig.volume;
        return soundItem;
    }
    mute(muteStatus: boolean) {
        Object.keys(this.soundsList).forEach((soundKey) => {
            const soundItem = this.soundsList[soundKey];
            soundItem.instance.mute(muteStatus);
        });
    }
    setVolume(volumeValue?: number) {
        if (volumeValue) {
            if (!Store.soundOn) this.mute(false);
            this.volume = volumeValue;
            Object.keys(this.soundsList).forEach((soundKey) => {
                const soundItem = this.soundsList[soundKey];
                soundItem.instance.volume(volumeValue * soundItem.volume);
            });
        } else {
            this.mute(true);
        }
    }
    preload(file: string, ext: string, name: string) {
        const extensions = ext.split(',');
        const src = [] as string[];
        extensions.forEach((e) => {
            src.push(`${window.location.origin}/assets/sfx/${file}.${e}`);
        });
        const newHowlSoundSrc = new Howl({ src });
        this.soundsList[name] = {
            instance: newHowlSoundSrc,
            volume: 1,
        };
    }
}

export const SoundManager = new SoundController();
